var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.074.029c.342-.084.7.016.947.264l8.686 8.687a1 1 0 01-.41 1.662 7.963 7.963 0 01-4.524.057l-3.578 3.579a10.242 10.242 0 01.342 7.019 1 1 0 01-1.662.41l-5.084-5.082-7.084 7.082a.999.999 0 11-1.414-1.414l7.084-7.082-5.084-5.084a1 1 0 01.41-1.662 10.31 10.31 0 017.022.328l3.58-3.578A7.943 7.943 0 0113.36.703a1 1 0 01.715-.674zM11.59 12.412a8.25 8.25 0 00-6.563-2.379l8.943 8.941a8.223 8.223 0 00-2.38-6.562zm2.575-5.228l-2.614 2.612c.514.353 1.002.752 1.453 1.202.45.45.834.945 1.186 1.458l2.617-2.619a7.925 7.925 0 01-1.483-1.157 7.926 7.926 0 01-1.159-1.496zm.833-4.086a5.922 5.922 0 001.74 4.167A5.89 5.89 0 0020.898 9z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconPin;